import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationResult, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class OauthService {
  private baseUrl: string = environment.apiUrl;
  constructor(
    private httpClient: HttpClient
  ) { }

  addCloudIntegration(request: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + "/cloudIntegrations", request);
  }

  startCloudIntegration(request: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + "/cloudIntegrations/start", request);
  }

  getAllCloudIntegrationPag(pageNumber: number, pageSize: number): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/cloudIntegrations?pageNumber=${pageNumber}&pageSize=${pageSize}`);
  }

  disconnectCloudIntegration(id: number): Observable<any> {
    return this.httpClient.patch<any>(this.baseUrl + "/cloudIntegrations/deactivate/" + id, {});
  }

  getAllCloudIntegration(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/cloudIntegrations/options`);
  }

  getAllCloudIntegrationLogsPag(pageNumber: number, pageSize: number, logSheetTemplateId: number): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/cloudIntegrations/delivery-logs/${logSheetTemplateId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
  }
}
